module.exports = __webpack_public_path__ + "img/footer.9071b77f.png";